import {ActionEnum} from "../action.enum";
import {ChecklistTemplateVersion} from "../../models/checklist-template/checklist-template-version";


export namespace ChecklistTemplateVersionReleasedClassesAction {

  export class Initialize {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_VERSION_RELEASED_CLASSES_INITIALIZE;
    constructor (public version: ChecklistTemplateVersion) {}
  }

  export class ChangeSelection {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_VERSION_RELEASED_CLASSES_CHANGE_SELECTION;
    constructor (public ids: Set<string>) {}
  }

  export class Save {
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_VERSION_RELEASED_CLASSES_SAVE;
    constructor () {}
  }

  export class ResetToInitialSelection{
    static readonly type: ActionEnum = ActionEnum.CHECKLIST_TEMPLATE_VERSION_RELEASED_CLASSES_RESET_TO_INITIAL_SELECTION;
    constructor () {}
  }

}
